import store from '@/store'
let defaultSettings = require('@/settings')
export default function getPageTitle(pageTitle) {
  var  title =store.getters.web_title?store.getters.web_title:defaultSettings.title||'Vue Element Admin'
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
